import { useNavigate, useLocation } from 'react-router-dom'
import { Shield, LogOut, FileText, Sparkles, ArrowUpRight, Users, Settings, LayoutDashboard, Gauge } from 'lucide-react'
import { SelfLoadingAlarmBell } from './console/AlarmBell'
import { useAuthStore } from '../stores/authStore'

// BRIEF-E5d: the customer's old icon-only header (ClientNavigation: shield,
// bell to /client/alerts, "First meeting") is gone. Every /client page wears
// SocShell (components/soc/SocShell.tsx). The staff headers stay here.

export function AnalystNavigation() {
  const navigate = useNavigate()
  const location = useLocation()
  const logout = useAuthStore((s) => s.logout)

  const navItems = [
    { path: '/console', label: 'Console', icon: Gauge },
    { path: '/analyst', label: 'Queue', icon: FileText },
    { path: '/analyst/knowledge', label: 'World', icon: Sparkles },
    { path: '/analyst/escalations', label: 'Escalations', icon: ArrowUpRight },
    { path: '/analyst/onboard', label: 'Onboard', icon: Users },
    { path: '/admin', label: 'Admin', icon: Settings },
  ]

  return (
    <nav className="bg-navy text-white border-b border-gray-800">
      <div className="max-w-7xl mx-auto flex items-center justify-between px-6 py-3">
        <button
          type="button"
          onClick={() => navigate('/analyst')}
          className="flex items-center gap-2 tap-min"
          aria-label="Analyst console home"
        >
          <Shield className="w-5 h-5 text-brass" aria-hidden="true" />
          <span className="font-serif text-base tracking-widest uppercase" style={{ color: '#c49a5a' }}>
            Digital Watch
          </span>
          <span className="text-xs text-gray-500 ml-1">Analyst Console</span>
        </button>

        <div className="flex items-center gap-1">
          {navItems.map((item) => (
            <button
              key={item.path}
              type="button"
              onClick={() => navigate(item.path)}
              className={`flex items-center gap-1.5 tap-min px-3 py-2 rounded-lg text-sm transition-colors ${
                location.pathname === item.path || location.pathname.startsWith(item.path + '/')
                  ? 'bg-brass/20 text-brass-light'
                  : 'text-gray-400 hover:text-white'
              }`}
              aria-label={item.label}
            >
              <item.icon className="w-4 h-4" aria-hidden="true" />
              {item.label}
            </button>
          ))}

          {/* BRIEF-F1b item 2: unacknowledged platform alarms; opens the
              console's Alarms section. */}
          <SelfLoadingAlarmBell className="text-gray-400" />

          <button
            type="button"
            onClick={logout}
            className="flex items-center gap-1.5 tap-min px-3 py-2 rounded-lg text-sm text-gray-400 hover:text-white transition-colors ml-2"
            aria-label="Sign out"
          >
            <LogOut className="w-4 h-4" aria-hidden="true" />
          </button>
        </div>
      </div>
    </nav>
  )
}

export function AdminNavigation() {
  const navigate = useNavigate()
  const location = useLocation()
  const logout = useAuthStore((s) => s.logout)

  const navItems = [
    { path: '/admin', label: 'Overview', icon: LayoutDashboard },
  ]

  return (
    <nav className="bg-navy text-white border-b border-gray-800">
      <div className="max-w-7xl mx-auto flex items-center justify-between px-6 py-3">
        <button
          type="button"
          onClick={() => navigate('/admin')}
          className="flex items-center gap-2 tap-min"
          aria-label="Admin panel home"
        >
          <Shield className="w-5 h-5 text-brass" aria-hidden="true" />
          <span className="font-serif text-base tracking-widest uppercase" style={{ color: '#c49a5a' }}>
            Digital Watch
          </span>
          <span className="text-xs text-gray-500 ml-1">Admin</span>
        </button>

        <div className="flex items-center gap-1">
          {navItems.map((item) => (
            <button
              key={item.path}
              type="button"
              onClick={() => navigate(item.path)}
              className={`flex items-center gap-1.5 tap-min px-3 py-2 rounded-lg text-sm transition-colors ${
                location.pathname === item.path || location.pathname.startsWith(item.path + '/')
                  ? 'bg-brass/20 text-brass-light'
                  : 'text-gray-400 hover:text-white'
              }`}
            >
              <item.icon className="w-4 h-4" aria-hidden="true" />
              {item.label}
            </button>
          ))}

          <button
            type="button"
            onClick={() => navigate('/analyst')}
            className="flex items-center gap-1.5 tap-min px-3 py-2 rounded-lg text-sm text-gray-400 hover:text-white transition-colors"
            aria-label="Analyst console"
          >
            <FileText className="w-4 h-4" aria-hidden="true" />
            Analyst
          </button>

          <button
            type="button"
            onClick={logout}
            className="flex items-center gap-1.5 tap-min px-3 py-2 rounded-lg text-sm text-gray-400 hover:text-white transition-colors ml-2"
            aria-label="Sign out"
          >
            <LogOut className="w-4 h-4" aria-hidden="true" />
          </button>
        </div>
      </div>
    </nav>
  )
}
